import { ClipboardList, CheckCircle2, Package, Truck, ThumbsUp } from "lucide-react";

// linha do tempo padrão do pedido (usada em /acompanhar e /pedidos)
export const ORDER_TIMELINE = [
  { key: "aguardando_confirmacao", label: "Pedido recebido", icon: ClipboardList },
  { key: "confirmado", label: "Confirmado", icon: CheckCircle2 },
  { key: "em_separacao", label: "Em separação", icon: Package },
  { key: "saiu_para_entrega", label: "Saiu para entrega", icon: Truck },
  { key: "entregue", label: "Entregue", icon: ThumbsUp },
];

export const OrderTimeline = ({ status }) => {
  const currentIdx = ORDER_TIMELINE.findIndex((t) => t.key === status);
  return (
    <ol className="flex items-start" data-testid="order-timeline">
      {ORDER_TIMELINE.map((t, i) => {
        const Icon = t.icon;
        const reached = currentIdx >= i;
        const current = currentIdx === i;
        return (
          <li key={t.key} className="flex-1 flex flex-col items-center text-center relative">
            {i > 0 && (
              <span className={`absolute top-4 right-1/2 w-full h-0.5 ${currentIdx >= i ? "bg-brand" : "bg-gray-200"}`} />
            )}
            <span
              className={`relative z-10 w-8 h-8 rounded-full flex items-center justify-center ${
                reached ? "bg-brand text-white" : "bg-gray-100 text-gray-300"
              } ${current ? "ring-4 ring-brand/20" : ""}`}
            >
              <Icon className="w-4 h-4" />
            </span>
            <span className={`mt-2 text-[10px] sm:text-xs font-medium leading-tight ${reached ? "text-gray-800" : "text-gray-400"}`}>
              {t.label}
            </span>
          </li>
        );
      })}
    </ol>
  );
};
